// v0.6 — single source of truth for the OSS registration date.
//
// Extracted to its own dependency-free module (not exported from
// ClientEditForm.jsx directly) so it can be unit-tested without pulling in
// the whole component's UI import graph. Same pattern as reviewCanonical.js.
//
// Previously oss_registration_date and an OSS_UNION row's own
// registration_date were two independently-editable fields that could
// silently disagree — confirmed on the real DFLT client (2024-01-01 vs
// 2020-01-01 for the same registration). This makes it structurally
// impossible for the two to diverge instead of just flagging it.
export const isOssType = (t) => t === "OSS_UNION" || t === "OSS_NON_UNION" || t === "OSS";

// Collapse any pre-existing OSS row/oss_registration_date disagreement the
// moment a client is loaded for editing.
export const normalizeOssDates = (client) => {
  const ossDate = client.oss_registration_date || "";
  const rows = (client.company_vat_numbers || []).map((r) =>
    isOssType(r.registration_type) && r.registration_date !== ossDate
      ? { ...r, registration_date: ossDate }
      : r);
  // v0.6.8 fix — found live 2026-09-06: only the date was ever kept in
  // sync here. oss_msi_country/oss_registration_number were NEVER
  // synced (they only started being read/written together once
  // ClientEditForm's v0.6.8 OSS-section split introduced setOssField),
  // so a legacy client whose real MSI country/number lived only on the
  // OSS array entry (set via the old per-row table UI) loads with
  // BLANK top-level fields — the new OSS section renders empty even
  // though real data exists. Worse, ClientEditForm's setOssType
  // rebuilds the array entry FROM these top-level fields on every
  // scheme change, so the blank top-level value would then silently
  // overwrite the real one the next time the operator touched the OSS
  // scheme dropdown at all — a live rewrite of the compliance-critical
  // OSS establishment_country calc_regime_dispatch.py reads (fixed
  // earlier this same session in ffd564e). Backfill top-level FROM the
  // array entry (not the other way around, unlike the date above) —
  // the array is the pre-existing source of truth for legacy data.
  const ossEntry = rows.find((r) => isOssType(r.registration_type));
  return {
    ...client,
    company_vat_numbers: rows,
    oss_msi_country: client.oss_msi_country || ossEntry?.country_code || "",
    oss_registration_number:
      client.oss_registration_number || ossEntry?.vat_number || "",
  };
};
